<template>
  <form-button-group
    :mobile="sdk.mobile"
    align="right"
    class="proposals-read-actions"
  >
    <form-button
      v-if="canDelete"
      :size="sdk.mobile ? 'small' : undefined"
      color="danger"
      icon="trash"
      @click="deleteOpen"
    >
      Remover
    </form-button>

    <modal-confirmation
      v-if="deleteConfirmation"
      :loading="deleting"
      color="danger"
      title="Remover proposta"
      @close="deleteClose"
      @confirm="deleteSubmit"
    >
      Você tem certeza que deseja remover esta proposta?
    </modal-confirmation>

    <form-button
      v-if="canPrint"
      :size="sdk.mobile ? 'small' : undefined"
      color="secondary"
      icon="print"
      target="_blank"
      :href="printURL"
    >
      Imprimir
    </form-button>

    <form-button
      v-if="canCreate"
      :size="sdk.mobile ? 'small' : undefined"
      icon="plus"
      @click="createToggle"
    >
      Nova tentativa
    </form-button>

    <modal-base
      v-if="createConfirmation"
      title="Nova tentativa"
      center
      @close="createToggle"
    >
      <form-button-group
        direction="vertical"
        stretch
      >
        <form-button
          :href="createIntegrated"
        >
          Nova tentativa em bancos integrados
        </form-button>

        <form-button
          color="secondary"
          :href="createManual"
        >
          Nova tentativa em outros bancos
        </form-button>
      </form-button-group>
    </modal-base>
  </form-button-group>
</template>

<script>
  import { mapState } from 'vuex';

  import mobile from '@sdk/helpers/interface/mobile';

  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  import ModalBase from '@cordel/components/Modal/Base.vue';
  import ModalConfirmation from '@cordel/components/Modal/Confirmation.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import persisted from '@/helpers/modules/auth';

  export default {
    name: 'ProposalsReadButtons',
    components: {
      FormButton,
      FormButtonGroup,

      ModalBase,
      ModalConfirmation,
    },
    mixins: [
      mobile,
    ],
    data() {
      return {
        createConfirmation: false,
        deleteConfirmation: false,

        persisted,
      };
    },
    computed: {
      ...mapState([
        'auth',
        'proposals',
        'proposalAttempts',
      ]),

      proposal() {
        return this.proposals.read.item;
      },
      attempts() {
        return this.proposalAttempts.list.items;
      },
      integrated() {
        return Object.keys(this.attempts)
          .some(id => this.attempts[id].external_simulation_uuid);
      },

      deleting() {
        return this.proposals.delete.loading;
      },

      canCreate() {
        if (!this.auth.user || !this.proposal) {
          return false;
        }

        const { store } = this.proposal;

        return !this.auth.user.role || this.auth.user.role.identifier !== 'salesman'
         || (store && store.seller_can_send_proposal_to_bank);
      },
      canPrint() {
        return !!this.$route.params.id;
      },
      canDelete() {
        if (!this.auth || !this.auth.user || !this.auth.user.role) {
          return false;
        }

        if ([
          'store_manager',
          'account_admin',
          'account_manager',
        ].indexOf(this.auth.user.role.identifier) === -1) {
          return false;
        }

        return Object
          .keys(this.attempts)
          .some(id => !this.attempts[id].external_proposal_uuid);
      },

      createManual() {
        return {
          name: 'proposal-attempts-new',
          params: {
            proposal_id: this.$route.params.id,
          },
          query: {
            integrated: false,
          },
        };
      },
      createIntegrated() {
        return {
          name: 'proposal-attempts-new',
          params: {
            proposal_id: this.$route.params.id,
          },
          query: {
            integrated: true,
          },
        };
      },

      printURL() {
        return `${persisted.environment.split('/api/v1')[0]}/proposals/${String(this.$route.params.id).replace(/\.pdf/, '')}.pdf`;
      },
    },
    methods: {
      createToggle() {
        if (this.integrated) {
          this.createConfirmation = !this.createConfirmation;

          return;
        }

        this.$router.push(this.createManual);
      },

      deleteSubmit() {
        this.$store
          .dispatch('proposals/delete', {
            id: this.$route.params.id,
          })
          .then(this.deleteSuccess)
          .catch(this.deleteFailure);
      },
      deleteSuccess() {
        this.$router.push({
          name: 'proposals-list',
        });
      },
      deleteFailure() {
        this.deleteClose();
      },
      deleteOpen() {
        this.deleteConfirmation = true;
      },
      deleteClose() {
        this.deleteConfirmation = false;
      },

      print() {
        const {
          id,
        } = this.$route.params;

        window.location.href = `/proposals/${id}.pdf`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .proposals-read-actions {
  }
</style>
